import { uuid, varchar } from 'drizzle-orm/pg-core/columns';
import { pgTable } from 'drizzle-orm/pg-core/table';
import { foreignKey } from 'drizzle-orm/pg-core/foreign-keys';
import { optionsRegistrations, optionsSharesRegistrations, shareIssueRegistrations } from './initial';
import { relations } from 'drizzle-orm/relations';
import { InferSelectModel, InferInsertModel } from 'drizzle-orm/table';
import { commonFields } from './common-fields';

export enum RegistrationTodoItemKind {
  BankNote = 'bank_note',
  PrintMeetingProtocol = 'print_meeting_protocol',
  PrintRegistrationForm = 'print_registration_form',
  SendToBolagsverket = 'send_to_bolagsverket',
  UpdateShareRegister = 'update_share_register',
}

export const registrationTodoCompletions = pgTable(
  'registration_todo_completions',
  {
    ...commonFields,
    companyId: uuid('company_id').notNull(),
    shareIssueRegistrationId: uuid('share_issue_registration_id'),
    optionsRegistrationId: uuid('options_registration_id'),
    optionsSharesRegistrationId: uuid('options_shares_registration_id'),
    kind: varchar().notNull().$type<RegistrationTodoItemKind>(),
  },
  table => [
    foreignKey({
      columns: [table.shareIssueRegistrationId],
      foreignColumns: [shareIssueRegistrations.id],
      name: 'registration_todo_items_share_issue_registration_id_fkey',
    }),
    foreignKey({
      columns: [table.optionsRegistrationId],
      foreignColumns: [optionsRegistrations.id],
      name: 'registration_todo_items_options_registration_id_fkey',
    }),
    foreignKey({
      columns: [table.optionsSharesRegistrationId],
      foreignColumns: [optionsSharesRegistrations.id],
      name: 'registration_todo_items_options_shares_registration_id_fkey',
    }),
  ],
);

export const registrationTodoCompletionsRelations = relations(registrationTodoCompletions, ({ one }) => ({
  shareIssueRegistration: one(shareIssueRegistrations, {
    fields: [registrationTodoCompletions.shareIssueRegistrationId],
    references: [shareIssueRegistrations.id],
  }),
  optionsRegistration: one(optionsRegistrations, {
    fields: [registrationTodoCompletions.optionsRegistrationId],
    references: [optionsRegistrations.id],
  }),
  optionsSharesRegistration: one(optionsSharesRegistrations, {
    fields: [registrationTodoCompletions.optionsSharesRegistrationId],
    references: [optionsSharesRegistrations.id],
  }),
}));

export type RegistrationTodoCompletion = InferSelectModel<typeof registrationTodoCompletions>;
export type RegistrationTodoCompletionCreate = InferInsertModel<typeof registrationTodoCompletions>;
